import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Select,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledTypography,
  StyledSecondaryTypography,
  TypographyDefault,
} from "../../Theme";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as BookingCalenderIcon } from "../../Icons/BookingCalenderIcon.svg";
import { ReactComponent as UploadIcon } from "../../Icons/UploadIcon.svg";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { useNavigate } from "react-router-dom";

const CreateNewAccount = () => {
  const [addblocks, setaddblocks] = useState({
    Company_Details: true,
    Project_Information: false,
    Administrator_Details: false,
    Review_Account: false,
  });

  const navigate = useNavigate();

  const blocks = [
    { status: addblocks.Company_Details, tle: "Company Details" },
    { status: addblocks.Project_Information, tle: "Project Information" },
    { status: addblocks.Administrator_Details, tle: "Administrator Details" },
    { status: addblocks.Review_Account, tle: "Review Account" },
  ];

  const Continue = (nxtval) => {
    setaddblocks({
      Company_Details: nxtval === "Company Details",
      Project_Information: nxtval === "Project Information",
      Administrator_Details: nxtval === "Administrator Details",
      Review_Account: nxtval === "Review Account",
    });
  };
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };

  const CompanyDetails = () => {
    return (
      <>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Company Details</SecondaryTypography>
          </Stack>
          <Box component="form">
            <Grid
              container
              xs={12}
              gap="20px"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12}>
                <StyledTypography>Select Company</StyledTypography>
                <Select
                  sx={{ width: "48%" }}
                  name="category"
                  displayEmpty
                  renderValue={() => "Select Company"}
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Company Name</StyledTypography>
                <TextField
                  name="Company_Name"
                  placeholder="Enter Company Name"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Country</StyledTypography>
                <TextField
                  name="Country"
                  placeholder="Country"
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Company Email Address</StyledTypography>
                <TextField
                  name="Company_Email_Address"
                  placeholder="Enter Company Email Address"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 125 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={5.77}>
                <StyledTypography style={{ marginBottom: "10px" }}>
                  Contact Number
                </StyledTypography>
                <PhoneInput
                  inputProps={{ name: "phone", maxLength: 20 }}
                  country={"th"}
                  buttonStyle={{ border: "none" }}
                  inputStyle={{
                    backgroundColor: "#F9FAFB",
                    border: "none",
                    height: "46px",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                  countryCodeEditable={false}
                />
              </Grid>
              <Grid xs={12}>
                <StyledTypography>Company Address</StyledTypography>
                <TextField
                  name="Company_Address"
                  placeholder="Enter Company Address"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Billing Details</SecondaryTypography>
          </Stack>
          <Box component="form">
            <Grid
              container
              xs={12}
              gap="20px"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12} md={5.77}>
                <StyledTypography>Billing Entity</StyledTypography>
                <TextField
                  name="Billing_Entity"
                  placeholder="Enter first name"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Full Name</StyledTypography>
                <TextField
                  name="Full Name"
                  placeholder="Enter last name"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Billing Email Address </StyledTypography>
                <TextField
                  name="Billing_Email_Address "
                  placeholder="Billing Email Address "
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={5.77}>
                <StyledTypography style={{ marginBottom: "10px" }}>
                  Contact Number
                </StyledTypography>
                <PhoneInput
                  inputProps={{ name: "phone", maxLength: 20 }}
                  country={"th"}
                  buttonStyle={{ border: "none" }}
                  inputStyle={{
                    backgroundColor: "#F9FAFB",
                    border: "none",
                    height: "46px",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                  countryCodeEditable={false}
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Billing Cycle</StyledTypography>

                <Select
                  name="Biling"
                  displayEmpty
                  renderValue={() => "Billing Cycle"}
                />
              </Grid>

              <Grid xs={12} md={5.77}>
                <StyledTypography>Contract Terms</StyledTypography>
                <TextField
                  name="Contract_Terms"
                  placeholder="Enter Contract Terms"
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Commence Date</StyledTypography>
                <TextField
                  name="Commence Date"
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <BookingCalenderIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>End Date</StyledTypography>
                <TextField
                  name="End_Date"
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <BookingCalenderIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Contract</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12}>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{
                  padding: "24px 16px 24px 16px",
                  border: "1px solid #EAECF0",
                  borderRadius: "12px",
                  cursor: "pointer",
                }}
              >
                <Stack
                  flex={1}
                  direction="column"
                  alignItems="center"
                  textAlign="center"
                >
                  <UploadIcon />
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.svg,.gif"
                    hidden
                  />
                  <Stack my="5px" direction="row">
                    <Typography
                      marginRight="5px"
                      sx={{
                        fontSize: "14px !important",
                        fontWeight: "600 !important",
                        color: "#0E4965 !important",
                      }}
                    >
                      Click to upload
                    </Typography>
                    <StyledSecondaryTypography sx={{ color: "#4D5761" }}>
                      or drag and drop
                    </StyledSecondaryTypography>
                  </Stack>
                  <StyledSecondaryTypography
                    sx={{ color: "#4D5761", fontSize: "12px !important" }}
                  >
                    CSV, EXL (max. 25 megabytes)
                  </StyledSecondaryTypography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>

        <Box
          mt={3}
          bgcolor="#FFFFFF"
          sx={{
            border: "1px solid  #E5E7EB",
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "8px 8px 8px 8px",
          }}
        >
          <Stack
            direction="row"
            py={1}
            px={1}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button type="button" variant="contained">
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };
  const ProjectInformation = () => {
    return (
      <>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Project Information</SecondaryTypography>
          </Stack>
          <Box component="form">
            <Grid
              container
              xs={12}
              gap="20px"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12} md={5.77}>
                <StyledTypography>Project Title</StyledTypography>
                <TextField
                  name="Project_Title"
                  // placeholder="Enter Project Title"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 20 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Type</StyledTypography>
                <TextField
                  name="Type"
                  // placeholder="Type"
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Completion Year</StyledTypography>
                <TextField
                  name="Completion_Year"
                  // placeholder="Enter Completion Year"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 20 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Tenure</StyledTypography>
                <TextField
                  name="Tenure"
                  // placeholder="Enter Tenure"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 20 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>No. of Units</StyledTypography>
                <TextField
                  name="Units"
                  // placeholder="No. of Units"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Address</StyledTypography>
                <TextField
                  name="Address"
                  // placeholder="Enter Address"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Country</StyledTypography>
                <TextField
                  name="Country"
                  // placeholder="Enter Country"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>City / Province</StyledTypography>
                <TextField
                  name="City"
                  // placeholder="Enter The City"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Postal Code</StyledTypography>
                <TextField
                  name="Postal"
                  // placeholder="Postal Code"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Point of Contact</SecondaryTypography>
          </Stack>
          <Box component="form">
            <Grid
              container
              xs={12}
              gap="20px"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12} md={5.77}>
                <StyledTypography>Full Name</StyledTypography>
                <TextField
                  name="Full_Name"
                  // placeholder="Enter Project Title"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 20 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Position</StyledTypography>
                <TextField
                  name="Position"
                  // placeholder="Type"
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Email Address</StyledTypography>
                <TextField
                  name="Email_Address"
                  // placeholder="Enter Completion Year"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 20 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={5.77}>
                <StyledTypography style={{ marginBottom: "10px" }}>
                  Contact Number
                </StyledTypography>
                <PhoneInput
                  inputProps={{ name: "phone", maxLength: 20 }}
                  country={"th"}
                  buttonStyle={{ border: "none" }}
                  inputStyle={{
                    backgroundColor: "#F9FAFB",
                    border: "none",
                    height: "46px",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                  countryCodeEditable={false}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          mt={3}
          bgcolor="#FFFFFF"
          sx={{
            border: "1px solid  #E5E7EB",
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "8px 8px 8px 8px",
          }}
        >
          <Stack
            direction="row"
            py={1}
            px={1}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button type="button" variant="contained">
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };
  const AdministratorDetails = () => {
    return (
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Box style={{ flexDirection: "column" }}>
            <SecondaryTypography>Administrator Details</SecondaryTypography>
            <TypographyDefault style={{ marginTop: "5px" }}>
              These details will be used for the purpose of signing up as a
              Super Admin.
            </TypographyDefault>
          </Box>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              // borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Full Name</StyledTypography>
              <TextField
                name="Project_Title"
                // placeholder="Enter Project Title"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 20 }}
                fullWidth
              />
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Email Address</StyledTypography>
              <TextField
                name="Type"
                // placeholder="Type"
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
          sx={{
            backgroundColor: "white",
            border: "1px solid #E5E7EB",
            borderRadius: "0 0 8px 8px ",
          }}
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button type="button" variant="contained">
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    );
  };
  const ReviewAccount = () => {
    return (
      <>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Company Details</SecondaryTypography>
            </Stack>
            <Button
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Name
              </StyledSecondaryTypography>
              <TypographyDefault>
                Singapore Land Group Pte Ltd
              </TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Country</StyledSecondaryTypography>
              <TypographyDefault>Singapore</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>sgcontact@singaporeland.com</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contact Number
              </StyledSecondaryTypography>
              <TypographyDefault>+65 9890 4903</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore 048623
              </TypographyDefault>
            </Grid>
          </Grid>
        </Box>

        <Box
          // mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          // borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              // borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Billing Details</SecondaryTypography>
            </Stack>
            <Button
              // onClick={() => Continue("Personal Details", "")}
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contract Terms
              </StyledSecondaryTypography>
              <TypographyDefault>3 Years 0 Months</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Commence Date
              </StyledSecondaryTypography>
              <TypographyDefault>01 Aug 204</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
              <TypographyDefault>Desmond Ng</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Billing Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                finance_sg@singaporeland.com
              </TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Corporate Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore 048623
              </TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contact Number
              </StyledSecondaryTypography>
              <TypographyDefault>+65 9890 4903</TypographyDefault>
            </Grid>
          </Grid>
        </Box>

        <Box
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Project Information</SecondaryTypography>
            </Stack>
            <Button
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Project Title
              </StyledSecondaryTypography>
              <TypographyDefault>The Clement Canopy</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Type</StyledSecondaryTypography>
              <TypographyDefault>Residential</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                No. of Units
              </StyledSecondaryTypography>
              <TypographyDefault>505</TypographyDefault>;
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Address</StyledSecondaryTypography>
              <TypographyDefault>
                16 Clementi Ave 1, Singapore 129960
              </TypographyDefault>
            </Grid>

            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>contact@clementcanopy.sg</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contact Number
              </StyledSecondaryTypography>
              <TypographyDefault>+65 9050 9503</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Country</StyledSecondaryTypography>
              <TypographyDefault>Singapore</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>City</StyledSecondaryTypography>
              <TypographyDefault>Singapore</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Postal Code</StyledSecondaryTypography>
              <TypographyDefault>129960</TypographyDefault>
            </Grid>
          </Grid>
        </Box>

        <Box
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Administrator Details</SecondaryTypography>
            </Stack>
            <Button
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
              <TypographyDefault>Xiong Liang</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                xiongliang@singaporeland.com
              </TypographyDefault>
            </Grid>
          </Grid>
        </Box>
        <Box
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
            }}
          >
            <SecondaryTypography>Onboarded by</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Client Lead</StyledSecondaryTypography>
              <TypographyDefault>Keynes yeo</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Email</StyledSecondaryTypography>
              <TypographyDefault>keynesyeo@loby.tech</TypographyDefault>
            </Grid>
          </Grid>
        </Box>

        <Box
          bgcolor="#FFFFFF"
          sx={{
            border: "1px solid  #E5E7EB",
            borderTop: " 1px solid #F3F4F6",
            boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
            borderRadius: "0px 0px 8px 8px",
          }}
        >
          <Stack
            direction="row"
            py={2}
            px={2}
            justifyContent="end"
            alignItems="center"
            height="60px"
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                type="button"
                // onClick={AddStaff}
                sx={{ width: "fit-content" }}
                variant="Standard"
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };

  return (
    <>
      <Box>
        <BackArrow
          onClick={() => navigate("/sales-overview")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>Add New Account</PrimaryTypography>
      </Box>
      <Box sx={{ marginTop: "30px" }} display="flex" gap="1.5%" mb={5}>
        {blocks.map((itm) => (
          <Box
            key={itm.tle}
            onClick={() => Continue(itm.tle)}
            sx={{
              borderTop: itm.status ? "3px solid #0E4965" : "3px solid #D2D6DB",
              width: "25%",
              color: itm.status ? "#0E4965" : "#D2D6DB",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "12px",
                color: itm.status ? "#0E4965" : "#9DA4AE",
                padding: "10px 0 0 0",
              }}
            >
              {itm.tle}
            </Typography>
          </Box>
        ))}
      </Box>
      {addblocks.Company_Details && <CompanyDetails />}
      {addblocks.Project_Information && <ProjectInformation />}
      {addblocks.Administrator_Details && <AdministratorDetails />}
      {addblocks.Review_Account && <ReviewAccount />}
    </>
  );
};

export default CreateNewAccount;
